module.exports = __webpack_public_path__ + "static/media/variety_of_foods.d1dcd37b.webp";